import {PaymentProviders} from "./PaymentProviders";
export const isOver18 = (day, month, year) => {
	return new Date(parseInt(year) +18, parseInt(month)-1, day) <= new Date();
};
export const SwitchSubscriptionPlanType = Object.freeze({
	UPGRADE: "UPGRADE",
	DOWNGRADE: "DOWNGRADE"
});
export const statusNumberToStatusCode = {
	active: "active",
	renewing: "renewing",
	grace: "grace",
	expired: "expired",
	cancelled: "cancelled",
	draft: "draft",
	pendingEnding: "pendingEnding",
	ended: "ended",
	paused: "paused"
};
export const computeTags = async (subscriptionDetails, customerFetchingSuccess) => {
	const tagNames =  ["Membership", "ProductId", "CustomerId", "CustomerRelationId", "FirstMeal", "Otp", "SubscriptionCreatedDate", "SubscriptionSwitchedDate"];
	const mkTag = (tagName, value)  => {
		if (!tagNames.includes(tagName)) {
			throw new Error("No such tag");
		}
		return `(${tagName}, ${value})`;
	};
	const transformSubscriptionIdToProductId = (subscriptionIdentifier) => {
		switch(subscriptionIdentifier) {
		case "Employee": return 6843954;
		case "Basic": return 6807487;
		case "Premium": return 6807489;
		case "Exclusive": return 6807490;
		}
	};
	const tags = [];
	const extractPlanName = (plan) => {
		if (plan) {
			// this is the place where it is encoded that our plan names start with SunsetPlus
			// if a different name is planned to be supported this logic has to be updated
			const xs = plan.split("SunsetPLUS ");
			return xs.length > 1 ? xs[1] : undefined;
		}
		return undefined;
	};
	if (subscriptionDetails) {
		const { statusText, subscriptionPlanName, reference } = subscriptionDetails;

		const planName = extractPlanName(subscriptionPlanName);
		if (![statusNumberToStatusCode.cancelled, statusNumberToStatusCode.paused, statusNumberToStatusCode.draft].includes(statusText) && (customerFetchingSuccess || planName === "Employee")) {
			const getSwitchDate = (subscriptionData) => subscriptionData
				&& subscriptionData.meta
				&& subscriptionData.meta.subscription
				&& subscriptionData.meta.subscription.planSwitchDate;
			tags.push(
				mkTag("Membership", planName),
				mkTag("ProductId", transformSubscriptionIdToProductId(planName)),
				mkTag("CustomerId", 1),
				mkTag("FirstMeal", reference ? reference.freeMeal : false),
				mkTag("SubscriptionCreatedDate", subscriptionDetails.createdDate),
				mkTag("SubscriptionSwitchedDate", getSwitchDate(subscriptionDetails))
			);
		}
	}
	return tags;

};
export const handleRedirectBackFromSubscriptionPayment = (result, router, component, { isMobile, urlAccept, urlCancel, baseUrl, subscriptionPaymentMethod }, mobileCallback) => {
	const paymentUrl = result.paymentDetails && result.paymentDetails.hostedPaymentPageUrl;
	const state = {
		exitGracefully: false
	};
	if (paymentUrl) {
		if (isMobile) {
			const browserObjectModel = window.cordova ? window.cordova.InAppBrowser : window;
			const paymentProvider = PaymentProviders.find(paymentProvider => paymentProvider.name === subscriptionPaymentMethod) || PaymentProviders[0] ;
			const openBrowserIn = paymentProvider.browser;
			const ref = browserObjectModel.open(
				paymentUrl,
				openBrowserIn,
				"location=no,toolbar=yes,zoom=no"
			);
			ref.addEventListener("exit", () => {
				// eslint-disable-next-line no-console
				console.log("exited");
				if(!state.exitGracefully){
					component.$router.push(paymentProvider.redirectTo);
				}
			});
			ref.addEventListener("loadstart", event => {
				if (event.url.startsWith(urlAccept) || event.url.startsWith(urlCancel)) {
					ref.close();
					component.$router.push(event.url.replace(baseUrl, ""), mobileCallback);
					state.exitGracefully = true;
				}
			});

		} else {
			window.location.replace(paymentUrl);
		}
	}
};
export const manageMobilePaySubscriptions = (component) => {
	if (window.universalLinks) {
		window.universalLinks.subscribe("subscriptionMobilePayFinished",  () => {
			component.$router.push("/subscription-payment-done");
		});
	}
	if (window.universalLinks) {
		window.universalLinks.subscribe("manageAgreementInitialized",  () => {
			component.$router.push("/subscription-plans");
		});
	}
	const redirectToDone = (aIntent, router) => {
		const data = aIntent.data;
		if(data && data.includes("/subscription-plans")){
			router.push("/subscription-plans");
		}
	};
	if(window.plugins && window.plugins.intentShim){
		window.plugins.intentShim.onIntent(intent => redirectToDone(intent, component.$router));
	}
};
export const unsubscribeFromManageMobilePaySubscriptions = () => {
	if (window.universalLinks) {
		window.universalLinks.unsubscribe("manageAgreementInitialized");
		window.universalLinks.unsubscribe("subscriptionMobilePayFinished");
	}
};
export const getCustomerType = (data) => {
	if (data.subscriptionType) { return data.subscriptionType; }
	if (data.showSunsetPointsInfo) { return "SunsetPoints"; }
	return "Guest";
};
